export default "__VITE_ASSET__C81LFi0u__"